<div>
    <h3 style="text-align: center" class="titulo">LISTADO DE PERMISOS MÓDULOS</h3>
</div>

<div class="mt-5" style="width: 100%;">



    <!-- <button class="btn btn-success" (click)="openXL(contenido)"><i class="mdi mdi-account-plus"></i> Nuevo</button> -->
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped">

        <thead>
            <tr>
                <th>Id</th>
                <th>Cargo</th>
                <th>Permisos Módulos</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of users">

                <td>{{user.idcargo}}</td>
                <td>{{user.cargo}}</td>
                <!-- <td><button class="btn btn-success" (click)="openPermisos(permisos,user.idcargo,user.cargo)" title="Permisos"><i class="mdi mdi-account-check" style="font-size: 23px;;"></i></button></td> -->
                <td><button (click)="datos(user.cargo,user.idcargo)" type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#exampleModal"> Ver
  </button></td>
            </tr>
        </tbody>

    </table>





    <!-- Button trigger modal -->


    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Permisos módulos de: <strong style="color:#74322D">{{cargo}}</strong></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Tabla Permisos  -->

                    <table class="table" id="ejemplo" style="padding:60px; width: 50%;">

                        <thead>

                            <tr style="font-size: 12px;text-align: center; background-color: #787A7C; color: white;">
                                <th>Control Escolar</th>
                                <th>Program. Extra</th>
                                <th *ngIf="ControlDG">Catálogos</th>
                                <th *ngIf="ControlDG">Usuarios</th>
                                <th *ngIf="ControlDG">Pagos</th>
                                <th *ngIf="ControlDG">Preinscripción</th>
                                <th *ngIf="ControlDG">Permisos Modulos</th>
                                <th *ngIf="ControlDG">Ajedrez</th>
                                <th *ngIf="ControlDG">Descargas</th>
                                <th *ngIf="ControlDG">Reapertura por plantel</th>
                            </tr>
                        </thead>
                        <tbody style="text-align: center;">
                            <tr style="text-align: center;">

                                <td>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkControlEscolar" (change)="testCheckControlEscolar($event)" id="flexCheckDefault">
                                        <label class="form-check-label" for="flexCheckDefault">
                                    </label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkProgramExtra" (change)="testCheckProgramExtra($event)" id="flexCheckDefault2">
                                        <label class="form-check-label" for="flexCheckDefault2">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkCatalogos" (change)="testCheckCatalogos($event)" id="flexCheckDefault3">
                                        <label class="form-check-label" for="flexCheckDefault3">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkUsuarios" (change)="testCheckUsuarios($event)" id="flexCheckDefault4">
                                        <label class="form-check-label" for="flexCheckDefault4">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkOvh" (change)="testCheckOvh($event)" id="flexCheckDefault5">
                                        <label class="form-check-label" for="flexCheckDefault5">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkPreinscripcion" (change)="testCheckPreinscripcion($event)" id="flexCheckDefault6">
                                        <label class="form-check-label" for="flexCheckDefault6">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkPermisos" (change)="testCheckPermisos($event)" id="flexCheckDefault7">
                                        <label class="form-check-label" for="flexCheckDefault7">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkAjedrez" (change)="testCheckAjedrez($event)" id="flexCheckDefault8">
                                        <label class="form-check-label" for="flexCheckDefault8">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkDescargas" (change)="testCheckDescargas($event)" id="flexCheckDefault9">
                                        <label class="form-check-label" for="flexCheckDefault9">
                                    </label>
                                    </div>
                                </td>
                                <td *ngIf="ControlDG">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" [checked]="checkReapertura" (change)="testCheckReapertura($event)" id="flexCheckDefault10">
                                        <label class="form-check-label" for="flexCheckDefault10">
                                    </label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                    </table>


                    <!-- End Tabla Permisos -->
                </div>
                <div class="modal-footer">
                    <button (click)="savePermisos()" type="button" class="btn btn-outline-dark">Guardar</button>
                </div>
            </div>
        </div>
    </div>